import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { SyncMainUnitDataDialogComponent } from './sync-main-unit-data-dialog.component'
import { SyncMainUnitData } from './sync-rental-data'

@Injectable({
  providedIn: 'root',
})
export class SyncMainUnitDataDialogService {
  constructor(private dialog: DialogService) {}

  open(mainUnitId: string, data: SyncMainUnitData) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      data: { mainUnitId, data },
    }
    return this.dialog.openVariableDialog(SyncMainUnitDataDialogComponent, defaultConfig)
  }
}
